import { Component, OnInit, Input, Output, EventEmitter, Inject, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import * as sweetalertService from 'angular-sweetalert-service';
import { Sort, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatCheckboxModule } from '@angular/material';
import { UUID } from 'angular2-uuid';
import { DatePipe, Time } from '@angular/common';
//grid
import { AgGridNg2 } from 'ag-grid-angular';

import { forEach } from '@angular/router/src/utils/collection';
import { Timeouts } from 'selenium-webdriver';
import { GridOptions } from 'ag-grid';

import { GlobalsService } from '../services/globals.service';
import { UtilesService } from '../services/utiles.service';
import { VisitaService } from '../services/visita.service';
import { UsuarioService } from '../services/usuario.service';
import { VehiculoService } from '../services/vehiculo.service';
import { PuntoVisitaService } from '../services/punto-visita.service';
import { CompaniaService } from '../services/compania.service';

import { Resultado } from '../Models/Resultado';
import { Visita } from '../Models/Visita';
import { VisitaTarea } from '../Models/VisitaTarea';
import { Viaje } from '../Models/Viaje';
import { Usuario } from '../Models/Usuario';
import { Vehiculo } from '../Models/Vehiculo';
import { ViajeVisita } from '../Models/ViajeVisita';
import { PuntoVisita } from '../Models/PuntoVisita';


@Component({
  selector: 'app-visita',
  templateUrl: './visita.component.html',
  styleUrls: ['./visita.component.css']

})
export class VisitaComponent implements OnInit {


  public visita: Visita = new Visita();
  public visitas: Visita[];

  public tarea: VisitaTarea = new VisitaTarea();
  public tareas: VisitaTarea[];

  public viaje: Viaje = new Viaje();
  public viajes: Viaje[];

  public usuario: Usuario = new Usuario();
  public usuarios: Usuario[];

  public vehiculo: Vehiculo = new Vehiculo();
  public vehiculos: Vehiculo[];

  public viajeVisita: ViajeVisita = new ViajeVisita();
  public viajeVisitas: ViajeVisita[];

  public puntoVisita: PuntoVisita = new PuntoVisita();
  public PuntosVisitas: PuntoVisita[];

  public resultado: Resultado = new Resultado();

  public modoEdicion: boolean = false;
  public nuevoRegistro: boolean = false;
  public nuevoRegistroTarea: boolean = false;
  public lista: boolean = false;

  public modoNuevaViaje: boolean = false;

  public modoBuscarPunto: boolean = false;


  public actualizarCheckBox: boolean = false;
  public checked = false;

  public mostrarDetalles: boolean = false;

  public mostrarMapaPantalla: boolean = false;

  //grid
  public gridOptions = <GridOptions>{};

  public rowsSeleccionadas = [];
  public datosSeleccionados: Visita[];

  @ViewChild('agGrid') agGrid: AgGridNg2;
  @ViewChild('agGridTareas') agGridTareas: AgGridNg2;
  title = 'Vehiculos';

  columnDefs = [
    { headerName: 'Accion', width: 30, checkboxSelection: true, suppressSorting: true, suppressMenu: true, pinned: true, icons: { filter: ' ' } },
    { headerName: 'Nombre Punto', field: 'nombrePunto', icons: { filter: ' ' } },
    { headerName: 'Teléfono', field: 'telefono', icons: { filter: ' ' } },
    { headerName: 'Chofer', field: 'nombreUsuario', icons: { filter: ' ' } },
    { headerName: 'Vehiculo', field: 'idVehiculo', icons: { filter: ' ' } },
    { headerName: 'Estado', field: 'estadoVisita', icons: { filter: ' ' } }

  ];


  columnDefsTareas = [
    { headerName: 'Accion', width: 30, checkboxSelection: true, suppressSorting: true, suppressMenu: true, pinned: true, suppressSizeToFit: true },
    { headerName: 'Tipo Tarea', field: 'tipoTarea' },
    { headerName: 'Número Documento', field: 'numeroDocumento' },
    { headerName: 'Número Orden', field: 'numeroOrden' },
    { headerName: 'Clasificación', field: 'clasificacion' },
    { headerName: 'Código', field: 'codigo' },
    { headerName: 'Descripción', field: 'descripcion' },
    { headerName: 'Unidad de Medida', field: 'unidadMedida' },
    { headerName: 'Cantidad', field: 'cantidad' },

  ];

  columnDefsPuntosVisita = [
    { headerName: 'Nombre', field: 'nombrePunto', icons: { filter: ' ' } },
    { headerName: 'Telefono', field: 'telefono', icons: { filter: ' ' } },
    { headerName: 'Email', field: 'email', icons: { filter: ' ' } },
    { headerName: 'Zona', field: 'descripcionZona', icons: { filter: ' ' } },
    { headerName: 'Ruta', field: 'descripcionRuta', icons: { filter: ' ' } },
    { headerName: 'Estado', field: 'estado', icons: { filter: ' ' } }

  ];


  rowData: any[];
  rowDataTareas: any[];
  rowDataPuntosVisita: any[];
  private rowClassRules;

  //mapa
  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;
  public markers = [];
  location = 'default location, update when clicking on the map';
  public mostrarMapa: boolean = false;
  public latitude: number = undefined;
  public longitude: number = undefined;



  constructor(private visitaService: VisitaService,
    private globalServices: GlobalsService,
    private utilService: UtilesService,
    private usuarioService: UsuarioService,
    private vehiculoService: VehiculoService,
    private puntoVisitaService: PuntoVisitaService,
    private compania: CompaniaService) {


  }

  ngOnInit() {
    this.modoEdicion = false;
    this.CargarVisitas();

  }

  verBuscarPunto() {
    this.modoBuscarPunto = true;
    this.CargarPuntos();
  }


  enModoEdicion(): boolean {

    if (this.modoBuscarPunto === true) {
      return false;
    }

    if (this.mostrarDetalles === true) {
      return false;
    }

    if (this.mostrarMapaPantalla === true) {
      return false;
    }

    return this.modoEdicion === true;

  }

  //Guarda en un array las row seleccionadas para luego ser asignadas 
  onRowSelected(event) {
    let row = event.node.rowIndex;

    let dataRow = event.data;

    row = this.rowData.findIndex(f => f.idVisita == dataRow.idVisita);

    if (event.node.selected) {
      this.rowsSeleccionadas.push(row);
    }
    else {

      //lo elimina del array
      this.rowsSeleccionadas.splice(row, 1);

    }
    console.log(this.rowsSeleccionadas);

  }

  //click en el row de tareas, para que sean eliminadas
  onRowSelectedTareas(event) {
    let row = event.node.rowIndex;
    let datos;
    let rowdataTareasTemporal = [];
    swal({
      title: "Eliminar",
      text: "¿Desea eliminar la tarea?",
      buttons: {
        Cancelar: true,
        Aceptar: true,

      }
    }).then(val => {
      if (val === "Cancelar") {
        this.agGridTareas.api.deselectAll();

      }

      if (val === "Aceptar") {
        datos = this.rowDataTareas[row];
        if (this.visita.estadoVisita === undefined) {
          rowdataTareasTemporal = JSON.parse(JSON.stringify(this.rowDataTareas));
          this.rowDataTareas.splice(row, 1);

          this.agGridTareas.api.setRowData([]);
          this.agGridTareas.api.setColumnDefs([]);
          this.agGridTareas.api.refreshView();

          this.agGridTareas.api.setRowData(this.rowDataTareas);
          this.agGridTareas.api.setColumnDefs(this.columnDefsTareas);
          this.agGridTareas.api.refreshView();


          this.agGridTareas.api.deselectAll();


          swal({
            title: "Cormirmado",
            text: "La tarea ha sido eliminada",
            icon: "success"
          });
          return;
        }

        if (this.visita.estadoVisita === "ACTIVO") {
          this.EliminarTarea(this.globalServices.ObtenerCompania(), this.visita.idVisita, datos.idTarea);
          swal({
            title: "Cormirmado",
            text: "La tarea ha sido eliminada",
            icon: "success"
          });

          this.agGridTareas.api.deselectAll();
        }
        else {
          swal("Oops!", "No se puede eliminar la tarea si la visita está asignada", "error");

          this.agGridTareas.api.deselectAll();
          return;
        }

      }
    }

    );


  }

  // onSelectionChanged($event) {
  //   var rowCount = $event.api.getSelectedNodes().length;
  //   let row= $event.rowIndex;
  //   window.alert("selection changed, " + rowCount + " rows selected");
  // }

  //carga las visitas con el estado activo o asignado
  CargarVisitas() {
    try {

      this.visitaService.ObtenerVisitas(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.visitas = data;
          this.rowData = JSON.parse(JSON.stringify(this.visitas));

          //  this.agGrid.gridOptions.rowClassRules={
          //   'rag-green-outer': function(rowClassRules) { return rowClassRules.data.year === 2008}
          //  } 
          this.CargarReferencia();

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarVisitas: " + error);
    }
  }

  // carga la latitud y longitud de la compañia
  CargarReferencia() {

    this.compania.ObtenerCompania(this.globalServices.ObtenerCompania()).subscribe(
      data => {

        this.latitude = parseFloat(data.latitud);
        this.longitude = parseFloat(data.logitud);
      },
      err => {
        console.clear();
        console.log(err._body);

      });

  }


  CargarVisitaListaTareas(idVsita: string) {
    try {

      return this.visitaService.ObtenerVisitaListaTareas(this.globalServices.ObtenerCompania(), idVsita).subscribe(
        data => {
          this.visita = data;
          this.rowDataTareas = this.visita.tareas;
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarVisitas: " + error);
    }
  }

  CargarPuntoVisita(idPunto: string) {
    try {

      return this.puntoVisitaService.ObtenerPuntoVisita(this.globalServices.ObtenerCompania(), idPunto).subscribe(
        data => {
          this.puntoVisita = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarPuntoVisita: " + error);
    }
  }

  ///Lista de visitas
  RegistroSeleccionado(item) {
    var visita1 = new Visita();
    //Se debe clonar el item para que no afecte el array origen en memoria
    this.nuevoRegistro = false;
    this.visita = JSON.parse(JSON.stringify(item));
    this.modoEdicion = true;

    //  this.CargarVisitaListaTareas(this.visita.idVisita);
    this.visita.tareas = visita1.tareas;

  }
  ///Lista de tareas
  RegistroSeleccionadoTareas(item) {
    this.tarea = JSON.parse(JSON.stringify(item));
    this.nuevoRegistro = false;
    this.modoEdicion = false;
    this.nuevoRegistroTarea = true;

    this.nuevoRegistro = false;
    this.lista = true;
    console.log(this.tarea);
  }


  GuardarRegistro() {

    this.visita.idCompania = this.globalServices.ObtenerCompania();


    if (this.visita.estadoVisita === undefined) {
      this.visita.estadoVisita = "ACTIVO";
    }


    if (this.visita.tareas === undefined) {

      swal("Oops!", "Necesita tareas para poder crear la visita", "error");
      return;
    }

    if (this.visita.idVisita === undefined) {
      this.visita.idVisita = UUID.UUID();
    }

    this.visita.tareas.forEach(item => {
      item.idVisita = this.visita.idVisita
    });


    if (this.visita.ventanaInicio === undefined) {

      this.visita.ventanaInicio = null;
    }

    if (this.visita.ventanaFin === undefined) {

      this.visita.ventanaFin = null;

    }


    if (this.actualizarCheckBox === true) {



      if (this.visita.idPunto === undefined) {
        this.visita.idPunto = UUID.UUID();
        this.puntoVisita.idPunto = this.visita.idPunto;

        this.puntoVisita.idZona = undefined;
        this.puntoVisita.idZona = undefined;
      }
      else {
        this.puntoVisita.idPunto = this.visita.idPunto;
      }

      this.puntoVisita.idCompania = this.visita.idCompania;
      this.puntoVisita.direccion = this.visita.direccion;
      this.puntoVisita.nombrePunto = this.visita.nombrePunto;
      this.puntoVisita.longitud = this.visita.longitud;
      this.puntoVisita.latitud = this.visita.latitud;
      this.puntoVisita.telefono = this.visita.telefono;
      this.puntoVisita.email = this.visita.email;
      this.puntoVisita.nombreContacto = this.visita.nombreContacto;
      this.puntoVisita.estado = "ACTIVO";


      this.puntoVisitaService.GuardarRegistro(this.puntoVisita).subscribe(
        data => {

          swal("Registro guardado con éxito!", "", "success");

          this.puntoVisita = new PuntoVisita();
          //  this.modoEdicion = false;

          // this.CargarPuntos();

        },
        err => {
          console.error(err);

        }

      );
    }


    console.log(this.visita);
    this.visitaService.GuardarRegistro(this.visita).subscribe(

      data => {

        if(data.tipoResultado==="ERROR"){
          swal("Hubo un error, "+data.mensaje, "", "error");
          return;
        }

        swal("Registro guardado con éxito!", "", "success");

        this.visita = new Visita();
        this.modoEdicion = false;

        this.CargarVisitas();

      },
      err => {
        console.log("GuardarRegistro: " + err);
      }

    );


  }


  //Guarda la TAREA en la lista
  GuardarRegistroTarea() {

    this.tarea.idCompania = this.globalServices.ObtenerCompania();
    this.tarea.estadoTarea = "ACTIVO";
    if (this.visita.tareas === undefined) {
      this.visita.tareas = [];
      // this.rowDataTareas= this.visita.tareas;
    }

    if (this.tarea.idTarea === undefined) {
      this.tarea.idTarea = UUID.UUID();
      this.visita.tareas.push(this.tarea);
      // this.rowDataTareas.push(   this.visita.tareas);
      this.rowDataTareas = this.visita.tareas;
    }
    else {
      let index = this.visita.tareas.findIndex(tarea => tarea.idTarea === this.tarea.idTarea);
      // alert(index);
      this.visita.tareas.splice(index, 1);
      this.visita.tareas.push(this.tarea);
      // this.rowDataTareas.push(   this.visita.tareas);
      this.rowDataTareas = this.visita.tareas;
    }

    // if (this.visita === undefined) {
    //   swal("Debe Crear la visita primero", "", "Error");
    // }

    //  this.agGridTareas.api.updateRowData({remove: this.rowDataTareas});
    // this.agGridTareas.api.updateRowData({add:this.rowDataTareas});
    this.agGridTareas.api.setRowData([]);
    this.agGridTareas.api.setColumnDefs([]);
    this.agGridTareas.api.refreshView();

    this.agGridTareas.api.setRowData(this.rowDataTareas);
    this.agGridTareas.api.setColumnDefs(this.columnDefsTareas);
    this.agGridTareas.api.refreshView();

    this.nuevoRegistroTarea = false;
    this.modoEdicion = true;
    this.nuevoRegistro = true;
    this.lista = false;
    console.log(this.tarea);
    this.tarea = new VisitaTarea();
    // this.rowDataTareas=[];
  }


  NuevoRegistro() {
    this.nuevoRegistro = true;
    this.visita = new Visita();
    this.tarea = new VisitaTarea();
    this.modoEdicion = true;
    this.nuevoRegistroTarea = false;
    this.rowDataTareas = [];
    //this.actualizarPuntoVisita=false;
  }

  CancelarEdicion() {
    this.visita = new Visita();
    this.modoEdicion = false;
    this.nuevoRegistroTarea = false;
    this.rowDataTareas = [];
    this.rowsSeleccionadas = [];

  }


  MostrarTarea() {
    // this.nuevoRegistroTarea = true;
    // this.modoEdicion = false;
    // this.nuevoRegistro = false;
    // this.lista = true;
    this.mostrarDetalles = true;
  }

  CancelarTarea() {
    // this.tarea = new VisitaTarea();
    // this.nuevoRegistroTarea = false;
    // this.modoEdicion = true;
    // this.nuevoRegistro = true;
    // this.lista = false;

    this.mostrarDetalles = false;
  }
  CancelarVisita() {
    this.visita = new Visita();
    this.viajeVisita = new ViajeVisita();
    this.datosSeleccionados = [];
    this.rowsSeleccionadas = [];
    this.nuevoRegistroTarea = false;
    this.modoEdicion = false;
    this.nuevoRegistro = false;
    this.lista = false;
    this.modoNuevaViaje = false;
  }



  AsignarTarea(item) {
    this.visita = JSON.parse(JSON.stringify(item));
    this.nuevoRegistroTarea = false;
    this.modoEdicion = false;
    this.nuevoRegistro = false;
    this.lista = true;
    this.modoNuevaViaje = true;

    this.CargarUsuarios();
    this.CargarVehiculos();
  }

  AsignarTareaGrid() {
    //this.visita = this.rowData[0];

    let elementos = JSON.parse(JSON.stringify(this.visitas));

    if (this.rowsSeleccionadas === undefined || this, this.rowsSeleccionadas.length == 0) {
      swal("Oops!", "Debe haber registros seleccionados para poder asignarlos", "error");
      return;
    }

    this.datosSeleccionados = [];



    this.rowsSeleccionadas.forEach(element => {

      this.datosSeleccionados.push(this.visitas[element]);

    });

    let filtroDatosSeleccionados = this.datosSeleccionados.filter(fil => fil.estadoVisita === 'ACTIVO');
    this.datosSeleccionados = filtroDatosSeleccionados;



    this.rowsSeleccionadas = [];
    this.nuevoRegistroTarea = false;
    this.modoEdicion = false;
    this.nuevoRegistro = false;
    this.lista = true;
    this.modoNuevaViaje = true;

    this.CargarUsuarios();
    this.CargarVehiculos();
  }


  CargarUsuarios() {

    try {

      this.usuarioService.ObtenerUsuarios(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.usuarios = data;



        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarUsuarios: " + error);
    }
  }



  CargarVehiculos() {

    try {

      this.vehiculoService.ObtenerVehiculos(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.vehiculos = data;



        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarVehiculos: " + error);
    }
  }


  // GuardarRegistroViaje() {
  //   //  var fecha: Date;

  //   // this.viaje.idCompania = this.globalServices.compania;
  //   //  this.viaje.estado = "ACTIVO";
  //   //  this.viaje.idUsuario=this.usuario.idUsuario;
  //   //  this.viaje.idVehiculo=this.vehiculo.idvehiculo;
  //   //  this.viaje.fechaAsignacion.getDate();
  //   //    this.viaje.fechaCreacion.getDate();
  //   if (this.viaje.idViaje === undefined) {
  //     this.viaje.idViaje = UUID.UUID();
  //   }
  //   this.viajeVisita.idVisita = this.visita.idVisita;
  //   this.viajeVisita.idCompania = this.visita.idCompania;
  //   this.viajeVisita.estado = "ACTIVO";
  //   this.viajeVisita.idUsuario = this.usuario.idUsuario
  //   this.viajeVisita.idVehiculo = this.vehiculo.idvehiculo;
  //   this.viajeVisita.idViaje = this.viaje.idViaje;
  //   this.viajeVisita.estadoViajeVisita = "ACTIVO";
  //   this.viajeVisita.fechaSincronizacionMovil = null;
  //   this.viajeVisita.fechaSincronizaacionNube = null;
  //   //this.viajeVisita.fechaInicio=null;
  //   // this.viajeVisita.fechaFinalizacion=null;


  //   console.log(this.viajeVisita);
  //   this.visitaService.GuardarRegistroViajeVisita(this.viajeVisita).subscribe(

  //     data => {

  //       swal("Registro guardado con éxito!", "", "success");

  //       this.viaje = new Viaje();
  //       this.visita = new Visita();
  //       this.viajeVisita = new ViajeVisita();

  //       this.nuevoRegistroTarea = false;
  //       this.modoEdicion = false;
  //       this.nuevoRegistro = false;
  //       this.lista = false;
  //       this.modoNuevaViaje = false;

  //       this.CargarVisitas();

  //     },
  //     err => {
  //       this.viaje = new Viaje();
  //       this.visita = new Visita();
  //       this.viajeVisita = new ViajeVisita();

  //       this.nuevoRegistroTarea = false;
  //       this.modoEdicion = false;
  //       this.nuevoRegistro = false;
  //       this.lista = false;
  //       this.modoNuevaViaje = false;
  //       swal("Oops!", "No podes asignar un viaje a un usuario y trasporte en uso", "error");
  //       this.CargarVisitas();
  //       console.log("GuardarRegistro: " + err);


  //     }

  //   );


  // }



  GuardarRegistroViajeGrid() {

    this.viajeVisitas = [];
    this.rowsSeleccionadas = [];

    this.datosSeleccionados.forEach(element => {
      if (this.viaje.idViaje === undefined) {
        this.viaje.idViaje = UUID.UUID();
      }
      this.viajeVisita.idViaje = this.viaje.idViaje;
      this.viajeVisita.idVisita = element.idVisita;
      this.viajeVisita.estado = 'ACTIVO';
      this.viajeVisita.estadoViajeVisita = "ACTIVO";
      this.viajeVisita.idCompania = element.idCompania;
      this.viajeVisita.idUsuario = this.usuario.idUsuario;
      this.viajeVisita.idVehiculo = this.vehiculo.idvehiculo;
      this.viajeVisita.fechaSincronizacionMovil = null;
      this.viajeVisita.fechaSincronizaacionNube = null;
      this.viajeVisita.fechaInicio = null;
      this.viajeVisita.fechaFinalizacion = null;

      this.viajeVisitas.push(this.viajeVisita);
      this.viajeVisita = new ViajeVisita();
      this.viaje.idViaje = undefined;
    });

    this.datosSeleccionados = [];
    console.log(this.viajeVisitas);
    this.visitaService.GuardarRegistroViajeVisita(this.viajeVisitas).subscribe(

      data => {
        this.rowDataTareas = [];
        swal("Registro guardado con éxito!", "", "success");

        this.viaje = new Viaje();
        this.visita = new Visita();
        this.viajeVisita = new ViajeVisita();

        this.nuevoRegistroTarea = false;
        this.modoEdicion = false;
        this.nuevoRegistro = false;
        this.lista = false;
        this.modoNuevaViaje = false;

        this.datosSeleccionados = [];

        this.rowsSeleccionadas = [];
        this.CargarVisitas();

      },
      err => {
        this.viaje = new Viaje();
        this.visita = new Visita();
        this.viajeVisita = new ViajeVisita();

        this.nuevoRegistroTarea = false;
        this.modoEdicion = false;
        this.nuevoRegistro = false;
        this.lista = false;
        this.modoNuevaViaje = false;
        this.datosSeleccionados = [];

        this.rowsSeleccionadas = [];

        this.rowDataTareas = [];
        swal("Oops!", "No podes asignar un viaje a un usuario y trasporte en uso", "error");
        this.CargarVisitas();
        console.log("GuardarRegistroViajeGrid: " + err);


      }

    );


  }






  private onCellClicked($event) {

    console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
    let row = $event.rowIndex;
    let datos = JSON.parse(JSON.stringify($event.data));

    let visita1 = new Visita();
    //Se debe clonar el item para que no afecte el array origen en memoria
    this.nuevoRegistro = false;
    this.visita = datos;
    this.CargarPuntoVisita(this.visita.idPunto);
    this.modoEdicion = true;

    this.CargarVisitaListaTareas(this.visita.idVisita);
    this.visita.tareas = visita1.tareas;
    //  this.rowDataTareas=visita1.tareas;
  }


  private onCellClickedTareas($event) {

    console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
    let row = $event.rowIndex;
    let datos = JSON.parse(JSON.stringify($event.data));

    this.tarea = datos;
    this.nuevoRegistro = false;
    this.modoEdicion = false;
    this.nuevoRegistroTarea = true;

    this.nuevoRegistro = false;
    this.lista = true;
  }

  private onCellClickedPuntosVisita($event) {

    console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
    let row = $event.rowIndex;
    let datos = JSON.parse(JSON.stringify($event.data));

    this.puntoVisita = datos;
    this.visita.idPunto = this.puntoVisita.idPunto;
    this.visita.longitud = this.puntoVisita.longitud;
    this.visita.latitud = this.puntoVisita.latitud;
    this.visita.nombrePunto = this.puntoVisita.nombrePunto;
    this.visita.direccion = this.puntoVisita.direccion;
    this.visita.email = this.puntoVisita.email;
    this.visita.telefono = this.puntoVisita.telefono;
    this.visita.nombreContacto = this.puntoVisita.nombreContacto;
    this.modoBuscarPunto = false;

  }



  //carga los puntos de visita para mostrar en la lista
  CargarPuntos() {
    try {

      this.puntoVisitaService.ObtenerPuntoVisitas(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.PuntosVisitas = data;

          this.rowDataPuntosVisita = this.PuntosVisitas;


        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarVehiculos: " + error);
    }

  }

  //localizacion
  cagarMapa() {

    this.map = new google.maps.Map(this.gmapElement.nativeElement, {


      center: {
        lat: this.latitude,
        lng: this.longitude
      },
      zoom: 15
    });

    google.maps.event.addListener(this.map, 'click', this.updateLocation.bind(this));

  }

  CrearPunto(latitud: number, longitud: number) {
    try {

      this.latitude = latitud;
      this.longitude = longitud;

      this.visita.latitud = latitud.toString();
      this.visita.longitud = longitud.toString();

      var marker = new google.maps.Marker({
        position: { lat: latitud, lng: longitud },
        map: this.map,
        title: this.puntoVisita.nombreContacto,
        //  draggable: true
      });

      this.markers.push(marker);

    } catch (error) {

    }
  }

  private updateLocation(event) {

    this.DeleteMarkers();

    this.location = event.latLng.toString();

    let loc = event.latLng.toJSON()

    this.visita.longitud = loc.lng;
    this.visita.latitud = loc.lat;


    this.CrearPunto(loc.lat, loc.lng);

  }

  DeleteMarkers() {
    try {

      //Loop through all the markers and remove
      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];

    } catch (error) {

    }

  };

  mostrarLocalizacion() {
    try {

      this.cagarMapa();

      this.mostrarMapaPantalla = true;

      if ((this.visita.latitud === undefined) || (this.visita.longitud === undefined)) {
        return;
      }


      if ((this.visita.latitud === "") || (this.visita.longitud === "")) {
        return;
      }


      this.latitude = parseFloat(this.visita.latitud);
      this.longitude = parseFloat(this.visita.longitud);


      this.CrearPunto(parseFloat(this.visita.latitud), parseFloat(this.visita.longitud));





      //geocerca

      // this.rutas .forEach(element => {

      //           if (element.cerca != undefined && (this.punto.idRuta==element.idRuta || this.IdRuta==element.idRuta )){
      //             for (var i = 0; i < element.cerca.length; i++) {
      //               let lati=parseFloat( element.cerca[i].latitud);
      //               let long= parseFloat( element.cerca[i].longitud);
      //               this.cercaCoords.push({ lat: lati, lng: long });
      //             }

      //           }
      //    });


      // this.mostrarPoligono();



    } catch (error) {

    }
  }


  CapturarGeoCerca() {
    try {

      this.mostrarMapaPantalla = false;

    } catch (error) {

    }
  }


  EliminarTarea(idCompania: string, idVsita: string, idTarea: string) {
    try {

      return this.visitaService.EliminarTarea(idCompania, idVsita, idTarea).subscribe(
        data => {
          this.resultado = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("EliminarTarea: " + error);
    }
  }


}


